// dunning action

import {
  GET_DUNNING_LIST,
  GET_DUNNING_LIST_FAILURE,
  GET_DUNNING_LIST_SUCCESS,
  GET_DUNNING_ACTION_LIST,
  GET_DUNNING_ACTION_LIST_SUCCESS,
  GET_DUNNING_ACTION_LIST_FAILURE,
  CREATE_DUNNING_EVENT,
  CREATE_DUNNING_EVENT_SUCCESS,
  CREATE_DUNNING_EVENT_FAILURE,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_SUCCESS,
  SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_FAILURE,
  GET_DUNNING_SINGLE_EVENT,
  GET_DUNNING_SINGLE_EVENT_SUCCESS,
  GET_DUNNING_SINGLE_EVENT_FAILURE,
  UPDATE_DUNNING_EVENT,
  UPDATE_DUNNING_EVENT_SUCCESS,
  UPDATE_DUNNING_EVENT_FAILURE,
  DELETE_DUNNING_EVENT,
  DELETE_DUNNING_EVENT_SUCCESS,
  DELETE_DUNNING_EVENT_FAILURE,
  ADD_NEW_DUNNING_EVENT_ACTION,
  ADD_NEW_DUNNING_EVENT_ACTION_SUCCESS,
  ADD_NEW_DUNNING_EVENT_ACTION_FAILURE,
  UPDATE_DUNNING_EVENT_ACTION,
  UPDATE_DUNNING_EVENT_ACTION_SUCCESS,
  UPDATE_DUNNING_EVENT_ACTION_FAILURE,
  DELETE_DUNNING_EVENT_ACTION,
  DELETE_DUNNING_EVENT_ACTION_SUCCESS,
  DELETE_DUNNING_EVENT_ACTION_FAILURE,
  GET_DUNNING_LOCK_TYPE_LIST,
  GET_DUNNING_LOCK_TYPE_LIST_SUCCESS,
  GET_DUNNING_LOCK_TYPE_LIST_FAILURE,
  GET_DUNNING_LOCK_TYPE_DATA,
  GET_DUNNING_LOCK_TYPE_DATA_SUCCESS,
  GET_DUNNING_LOCK_TYPE_DATA_FAILURE,
  CREATE_DUNNING_LOCK_TYPE,
  CREATE_DUNNING_LOCK_TYPE_SUCCESS,
  CREATE_DUNNING_LOCK_TYPE_FAILURE,
  UPDATE_DUNNING_LOCK_TYPE,
  UPDATE_DUNNING_LOCK_TYPE_SUCCESS,
  UPDATE_DUNNING_LOCK_TYPE_FAILURE,
  DELETE_DUNNING_LOCK_TYPE,
  DELETE_DUNNING_LOCK_TYPE_SUCCESS,
  DELETE_DUNNING_LOCK_TYPE_FAILURE,
  GET_DUNNING_LOCK_LIST,
  GET_DUNNING_LOCK_LIST_SUCCESS,
  GET_DUNNING_LOCK_LIST_FAILURE,
  GET_DUNNING_LOCK_DATA,
  GET_DUNNING_LOCK_DATA_SUCCESS,
  GET_DUNNING_LOCK_DATA_FAILURE,
  CREATE_DUNNING_LOCK,
  CREATE_DUNNING_LOCK_SUCCESS,
  CREATE_DUNNING_LOCK_FAILURE,
  UPDATE_DUNNING_LOCK,
  UPDATE_DUNNING_LOCK_SUCCESS,
  UPDATE_DUNNING_LOCK_FAILURE,
  DELETE_DUNNING_LOCK,
  DELETE_DUNNING_LOCK_SUCCESS,
  DELETE_DUNNING_LOCK_FAILURE,
  GET_DUNNING_PROFILE_LIST,
  GET_DUNNING_PROFILE_LIST_SUCCESS,
  GET_DUNNING_PROFILE_LIST_FAILURE,
  GET_DUNNING_PROFILE_DATA,
  GET_DUNNING_PROFILE_DATA_SUCCESS,
  GET_DUNNING_PROFILE_DATA_FAILURE,
  CREATE_DUNNING_PROFILE,
  CREATE_DUNNING_PROFILE_SUCCESS,
  CREATE_DUNNING_PROFILE_FAILURE,
  UPDATE_DUNNING_PROFILE,
  UPDATE_DUNNING_PROFILE_SUCCESS,
  UPDATE_DUNNING_PROFILE_FAILURE,
  DELETE_DUNNING_PROFILE,
  DELETE_DUNNING_PROFILE_SUCCESS,
  DELETE_DUNNING_PROFILE_FAILURE,
  GET_DUNNING_PROFILE_STEP_LIST,
  GET_DUNNING_PROFILE_STEP_LIST_SUCCESS,
  GET_DUNNING_PROFILE_STEP_LIST_FAILURE,
  GET_DUNNING_PROFILE_STEP_DATA,
  GET_DUNNING_PROFILE_STEP_DATA_SUCCESS,
  GET_DUNNING_PROFILE_STEP_DATA_FAILURE,
  CREATE_DUNNING_PROFILE_STEP,
  CREATE_DUNNING_PROFILE_STEP_SUCCESS,
  CREATE_DUNNING_PROFILE_STEP_FAILURE,
  UPDATE_DUNNING_PROFILE_STEP,
  UPDATE_DUNNING_PROFILE_STEP_SUCCESS,
  UPDATE_DUNNING_PROFILE_STEP_FAILURE,
  DELETE_DUNNING_PROFILE_STEP,
  DELETE_DUNNING_PROFILE_STEP_SUCCESS,
  DELETE_DUNNING_PROFILE_STEP_FAILURE,
} from "./actionType";

// Get Dunning List

export const getDunningList = () => ({
  type: GET_DUNNING_LIST,
});

export const getDunningListSuccess = (response) => ({
  type: GET_DUNNING_LIST_SUCCESS,
  payload: response,
});

export const getDunningListFailure = (error) => ({
  type: GET_DUNNING_LIST_FAILURE,
  payload: error,
});

// Get Dunning Action List

export const getDunningActionList = () => ({
  type: GET_DUNNING_ACTION_LIST,
});

export const getDunningActionListSuccess = (response) => ({
  type: GET_DUNNING_ACTION_LIST_SUCCESS,
  payload: response,
});

export const getDunningActionListFailure = (error) => ({
  type: GET_DUNNING_ACTION_LIST_FAILURE,
  payload: error,
});

// Create Dunning Event

export const createDunningEvent = (data) => ({
  type: CREATE_DUNNING_EVENT,
  payload: data,
});

export const createDunningEventSuccess = (response) => ({
  type: CREATE_DUNNING_EVENT_SUCCESS,
  payload: response,
});

export const createDunningEventFailure = (error) => ({
  type: CREATE_DUNNING_EVENT_FAILURE,
  payload: error,
});

// Search Single Customer Dunning Event List

export const searchSingleCustomerDunningEventList = (data) => ({
  type: SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST,
  payload: data,
});

export const searchSingleCustomerDunningEventListSuccess = (response) => ({
  type: SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_SUCCESS,
  payload: response,
});

export const searchSingleCustomerDunningEventListFailure = (error) => ({
  type: SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_FAILURE,
  payload: error,
});

// GET Dunning Single Event

export const getDunningSingleEvent = (data) => ({
  type: GET_DUNNING_SINGLE_EVENT,
  payload: data,
});

export const getDunningSingleEventSuccess = (response) => ({
  type: GET_DUNNING_SINGLE_EVENT_SUCCESS,
  payload: response,
});

export const getDunningSingleEventFailure = (error) => ({
  type: GET_DUNNING_SINGLE_EVENT_FAILURE,
  payload: error,
});

// Update Dunning Event

export const updateDunningEvent = (data) => ({
  type: UPDATE_DUNNING_EVENT,
  payload: data,
});

export const updateDunningEventSuccess = (response) => ({
  type: UPDATE_DUNNING_EVENT_SUCCESS,
  payload: response,
});

export const updateDunningEventFailure = (error) => ({
  type: UPDATE_DUNNING_EVENT_FAILURE,
  payload: error,
});

// Delete Dunning Event

export const deleteDunningEvent = (data) => ({
  type: DELETE_DUNNING_EVENT,
  payload: data,
});

export const deleteDunningEventSuccess = (response) => ({
  type: DELETE_DUNNING_EVENT_SUCCESS,
  payload: response,
});

export const deleteDunningEventFailure = (error) => ({
  type: DELETE_DUNNING_EVENT_FAILURE,
  payload: error,
});

// Add New Dunning Event Action

export const addNewDunningEventAction = (data) => ({
  type: ADD_NEW_DUNNING_EVENT_ACTION,
  payload: data,
});

export const addNewDunningEventActionSuccess = (response) => ({
  type: ADD_NEW_DUNNING_EVENT_ACTION_SUCCESS,
  payload: response,
});

export const addNewDunningEventActionFailure = (error) => ({
  type: ADD_NEW_DUNNING_EVENT_ACTION_FAILURE,
  payload: error,
});

// Update Dunning Event Action

export const updateDunningEventAction = (data) => ({
  type: UPDATE_DUNNING_EVENT_ACTION,
  payload: data,
});

export const updateDunningEventActionSuccess = (response) => ({
  type: UPDATE_DUNNING_EVENT_ACTION_SUCCESS,
  payload: response,
});

export const updateDunningEventActionFailure = (error) => ({
  type: UPDATE_DUNNING_EVENT_ACTION_FAILURE,
  payload: error,
});

// Delete Dunning Event Action

export const deleteDunningEventAction = (data) => ({
  type: DELETE_DUNNING_EVENT_ACTION,
  payload: data,
});

export const deleteDunningEventActionSuccess = (response) => ({
  type: DELETE_DUNNING_EVENT_ACTION_SUCCESS,
  payload: response,
});

export const deleteDunningEventActionFailure = (error) => ({
  type: DELETE_DUNNING_EVENT_ACTION_FAILURE,
  payload: error,
});

// Get Dunning Lock Type List

export const getDunningLockTypeList = () => ({
  type: GET_DUNNING_LOCK_TYPE_LIST,
});

export const getDunningLockTypeListSuccess = (response) => ({
  type: GET_DUNNING_LOCK_TYPE_LIST_SUCCESS,
  payload: response,
});

export const getDunningLockTypeListFailure = (error) => ({
  type: GET_DUNNING_LOCK_TYPE_LIST_FAILURE,
  payload: error,
});

// GET Dunning Lock Type Data

export const getDunningLockTypeData = (data) => ({
  type: GET_DUNNING_LOCK_TYPE_DATA,
  payload: data,
});

export const getDunningLockTypeDataSuccess = (response) => ({
  type: GET_DUNNING_LOCK_TYPE_DATA_SUCCESS,
  payload: response,
});

export const getDunningLockTypeDataFailure = (error) => ({
  type: GET_DUNNING_LOCK_TYPE_DATA_FAILURE,
  payload: error,
});

// Create Dunning Lock Type

export const createDunningLockType = (data) => ({
  type: CREATE_DUNNING_LOCK_TYPE,
  payload: data,
});

export const createDunningLockTypeSuccess = (response) => ({
  type: CREATE_DUNNING_LOCK_TYPE_SUCCESS,
  payload: response,
});

export const createDunningLockTypeFailure = (error) => ({
  type: CREATE_DUNNING_LOCK_TYPE_FAILURE,
  payload: error,
});

// Update Dunning Lock Type

export const updateDunningLockType = (data) => ({
  type: UPDATE_DUNNING_LOCK_TYPE,
  payload: data,
});

export const updateDunningLockTypeSuccess = (response) => ({
  type: UPDATE_DUNNING_LOCK_TYPE_SUCCESS,
  payload: response,
});

export const updateDunningLockTypeFailure = (error) => ({
  type: UPDATE_DUNNING_LOCK_TYPE_FAILURE,
  payload: error,
});

// Delete Dunning Lock Type

export const deleteDunningLockType = (data) => ({
  type: DELETE_DUNNING_LOCK_TYPE,
  payload: data,
});

export const deleteDunningLockTypeSuccess = (response) => ({
  type: DELETE_DUNNING_LOCK_TYPE_SUCCESS,
  payload: response,
});

export const deleteDunningLockTypeFailure = (error) => ({
  type: DELETE_DUNNING_LOCK_TYPE_FAILURE,
  payload: error,
});

// Get Dunning Lock List

export const getDunningLockList = () => ({
  type: GET_DUNNING_LOCK_LIST,
});

export const getDunningLockListSuccess = (response) => ({
  type: GET_DUNNING_LOCK_LIST_SUCCESS,
  payload: response,
});

export const getDunningLockListFailure = (error) => ({
  type: GET_DUNNING_LOCK_LIST_FAILURE,
  payload: error,
});

// GET Dunning Lock Data

export const getDunningLockData = (data) => ({
  type: GET_DUNNING_LOCK_DATA,
  payload: data,
});

export const getDunningLockDataSuccess = (response) => ({
  type: GET_DUNNING_LOCK_DATA_SUCCESS,
  payload: response,
});

export const getDunningLockDataFailure = (error) => ({
  type: GET_DUNNING_LOCK_DATA_FAILURE,
  payload: error,
});

// Create Dunning Lock

export const createDunningLock = (data) => ({
  type: CREATE_DUNNING_LOCK,
  payload: data,
});

export const createDunningLockSuccess = (response) => ({
  type: CREATE_DUNNING_LOCK_SUCCESS,
  payload: response,
});

export const createDunningLockFailure = (error) => ({
  type: CREATE_DUNNING_LOCK_FAILURE,
  payload: error,
});

// Update Dunning Lock

export const updateDunningLock = (data) => ({
  type: UPDATE_DUNNING_LOCK,
  payload: data,
});

export const updateDunningLockSuccess = (response) => ({
  type: UPDATE_DUNNING_LOCK_SUCCESS,
  payload: response,
});

export const updateDunningLockFailure = (error) => ({
  type: UPDATE_DUNNING_LOCK_FAILURE,
  payload: error,
});

// Delete Dunning Lock

export const deleteDunningLock = (data) => ({
  type: DELETE_DUNNING_LOCK,
  payload: data,
});

export const deleteDunningLockSuccess = (response) => ({
  type: DELETE_DUNNING_LOCK_SUCCESS,
  payload: response,
});

export const deleteDunningLockFailure = (error) => ({
  type: DELETE_DUNNING_LOCK_FAILURE,
  payload: error,
});

// Get Dunning Profile List

export const getDunningProfileList = () => ({
  type: GET_DUNNING_PROFILE_LIST,
});

export const getDunningProfileListSuccess = (response) => ({
  type: GET_DUNNING_PROFILE_LIST_SUCCESS,
  payload: response,
});

export const getDunningProfileListFailure = (error) => ({
  type: GET_DUNNING_PROFILE_LIST_FAILURE,
  payload: error,
});

// GET Dunning Profile Data

export const getDunningProfileData = (data) => ({
  type: GET_DUNNING_PROFILE_DATA,
  payload: data,
});

export const getDunningProfileDataSuccess = (response) => ({
  type: GET_DUNNING_PROFILE_DATA_SUCCESS,
  payload: response,
});

export const getDunningProfileDataFailure = (error) => ({
  type: GET_DUNNING_PROFILE_DATA_FAILURE,
  payload: error,
});

// Create Dunning Profile

export const createDunningProfile = (data) => ({
  type: CREATE_DUNNING_PROFILE,
  payload: data,
});

export const createDunningProfileSuccess = (response) => ({
  type: CREATE_DUNNING_PROFILE_SUCCESS,
  payload: response,
});

export const createDunningProfileFailure = (error) => ({
  type: CREATE_DUNNING_PROFILE_FAILURE,
  payload: error,
});

// Update Dunning Profile

export const updateDunningProfile = (data) => ({
  type: UPDATE_DUNNING_PROFILE,
  payload: data,
});

export const updateDunningProfileSuccess = (response) => ({
  type: UPDATE_DUNNING_PROFILE_SUCCESS,
  payload: response,
});

export const updateDunningProfileFailure = (error) => ({
  type: UPDATE_DUNNING_PROFILE_FAILURE,
  payload: error,
});

// Delete Dunning Profile

export const deleteDunningProfile = (data) => ({
  type: DELETE_DUNNING_PROFILE,
  payload: data,
});

export const deleteDunningProfileSuccess = (response) => ({
  type: DELETE_DUNNING_PROFILE_SUCCESS,
  payload: response,
});

export const deleteDunningProfileFailure = (error) => ({
  type: DELETE_DUNNING_PROFILE_FAILURE,
  payload: error,
});

// Get Dunning Profile Step List

export const getDunningProfileStepList = (data) => ({
  type: GET_DUNNING_PROFILE_STEP_LIST,
  payload: data,
});

export const getDunningProfileStepListSuccess = (response) => ({
  type: GET_DUNNING_PROFILE_STEP_LIST_SUCCESS,
  payload: response,
});

export const getDunningProfileStepListFailure = (error) => ({
  type: GET_DUNNING_PROFILE_STEP_LIST_FAILURE,
  payload: error,
});

// GET Dunning Profile Step Data

export const getDunningProfileStepData = (data) => ({
  type: GET_DUNNING_PROFILE_STEP_DATA,
  payload: data,
});

export const getDunningProfileStepDataSuccess = (response) => ({
  type: GET_DUNNING_PROFILE_STEP_DATA_SUCCESS,
  payload: response,
});

export const getDunningProfileStepDataFailure = (error) => ({
  type: GET_DUNNING_PROFILE_STEP_DATA_FAILURE,
  payload: error,
});

// Create Dunning Profile Step

export const createDunningProfileStep = (data) => ({
  type: CREATE_DUNNING_PROFILE_STEP,
  payload: data,
});

export const createDunningProfileStepSuccess = (response) => ({
  type: CREATE_DUNNING_PROFILE_STEP_SUCCESS,
  payload: response,
});

export const createDunningProfileStepFailure = (error) => ({
  type: CREATE_DUNNING_PROFILE_STEP_FAILURE,
  payload: error,
});

// Update Dunning Profile Step

export const updateDunningProfileStep = (data) => ({
  type: UPDATE_DUNNING_PROFILE_STEP,
  payload: data,
});

export const updateDunningProfileStepSuccess = (response) => ({
  type: UPDATE_DUNNING_PROFILE_STEP_SUCCESS,
  payload: response,
});

export const updateDunningProfileStepFailure = (error) => ({
  type: UPDATE_DUNNING_PROFILE_STEP_FAILURE,
  payload: error,
});

// Delete Dunning Profile Step

export const deleteDunningProfileStep = (data) => ({
  type: DELETE_DUNNING_PROFILE_STEP,
  payload: data,
});

export const deleteDunningProfileStepSuccess = (response) => ({
  type: DELETE_DUNNING_PROFILE_STEP_SUCCESS,
  payload: response,
});

export const deleteDunningProfileStepFailure = (error) => ({
  type: DELETE_DUNNING_PROFILE_STEP_FAILURE,
  payload: error,
});
